// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"TooltipDisplayHead_tooltip__2at7T","tooltip_right":"TooltipDisplayHead_tooltip_right__3N5af TooltipDisplayHead_tooltip__2at7T"};